import { BaseRouteService } from "core/services";

class CaseStatusRouteService extends BaseRouteService {
	constructor() {
		super("case-statuses");	
	}	
	
	lookup(filter) {
		return super.find(`${this.base}/lookup{?searchQuery}`, filter);
	}	
}

export default CaseStatusRouteService;